const STEPS = {
  welcome: {
    target: 'body',
    title: 'Bienvenue sur AccountInTime',
    content: 'Découvrons ensemble les fonctionnalités principales de votre logiciel de gestion comptable ! Cette visite guidée vous prendra moins de 2 minutes.',
    disableBeacon: true,
    placement: 'center',
  },
  dashboard: {
    target: '[data-tour="nav-dashboard"]',
    title: 'Tableau de Bord',
    content: 'Votre vue d\'ensemble : suivez en temps réel votre chiffre d\'affaires, les factures en attente, et les indicateurs clés de performance.',
    placement: 'right',
  },
  sales: {
    target: '[data-tour="nav-sales"]',
    title: 'Module Ventes',
    content: 'Gérez l\'intégralité de votre cycle de vente : clients, devis, factures, avoirs et encaissements. Chaque document est accessible en un clic.',
    placement: 'right',
  },
  purchases: {
    target: '[data-tour="nav-purchases"]',
    title: 'Module Achats',
    content: 'Suivez vos fournisseurs, factures d\'achat et règlements fournisseurs. Un module complet pour la gestion de vos dépenses.',
    placement: 'right',
  },
  treasury: {
    target: '[data-tour="nav-treasury"]',
    title: 'Trésorerie',
    content: 'Gérez votre caisse, vos comptes bancaires et les retenues à la source. Une vue complète de vos flux financiers en temps réel.',
    placement: 'right',
  },
  accounting: {
    target: '[data-tour="nav-accounting"]',
    title: 'Comptabilité',
    content: 'Module comptable complet : saisie manuelle, grand livre, balance, états financiers, postes clients/fournisseurs et lettrage.',
    placement: 'right',
  },
  workspace: {
    target: '[data-tour="workspace-selector"]',
    title: 'Sélection du Dossier Client',
    content: 'Pour les cabinets : basculez entre votre espace cabinet et les dossiers de vos clients. Chaque dossier possède ses propres données et paramètres.',
    placement: 'bottom',
  },
  quickActions: {
    target: '[data-tour="quick-actions"]',
    title: 'Actions Rapides',
    content: 'Accédez rapidement aux actions les plus courantes : nouvelle facture, nouveau client, enregistrer un paiement ou générer des factures automatiques.',
    placement: 'left',
  },
  done: {
    target: 'body',
    title: 'Prêt à démarrer !',
    content: 'Vous connaissez maintenant les bases. Explorez chaque module à votre rythme. Besoin d\'aide ? Utilisez le chat de support disponible en bas à droite.',
    placement: 'center',
  },
};

export const TOUR_STEPS = [
  'welcome',
  'dashboard',
  'sales',
  'purchases',
  'treasury',
  'accounting',
  'workspace',
  'quickActions',
  'done',
].map(key => STEPS[key]);

export const getStepByKey = (key) => STEPS[key] || null;
